export default __webpack_public_path__ + "static/media/56.e4d2b3b1.jpeg";